export default __webpack_public_path__ + "static/media/LogoName.c2b111e2.png";